/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Engagement_PeriodInputs */

const en_landing_preview_engagement_period = /** @type {(inputs: Landing_Preview_Engagement_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 12 months`)
};

/**
* | output |
* | --- |
* | "Last 12 months" |
*
* @param {Landing_Preview_Engagement_PeriodInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_engagement_period = /** @type {((inputs?: Landing_Preview_Engagement_PeriodInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Engagement_PeriodInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_engagement_period(inputs)
});